(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter-reminder-button-counter/assets/javascripts/payfooter-reminder-button-counter.js') >= 0) return;  svs.modules.push('/components/tur/payfooter-reminder-button-counter/assets/javascripts/payfooter-reminder-button-counter.js');

'use strict';

function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
svs = svs || {};
svs.tur = svs.tur || {};
var _source = new WeakMap();
var _initIsSubscription = new WeakMap();
var _intersectionOptions = new WeakMap();
var _payfooterInViewPort = new WeakMap();
var _footerInViewPort = new WeakMap();
var _clicked = new WeakMap();
var _animations = new WeakMap();
var _observer = new WeakMap();
var _hasAppended = new WeakMap();
var _elIcon = new WeakMap();
var _elBody = new WeakMap();
var _elAmount = new WeakMap();
var _elButton = new WeakMap();
var _elPayfooter = new WeakMap();
var _elPagefooter = new WeakMap();
var _PayfooterReminderButtonCounter_brand = new WeakSet();
var _onSumUpdated = new WeakMap();
var _clickHandler = new WeakMap();
class PayfooterReminderButtonCounter extends svs.tur.Base {
  constructor() {
    var _ref2, _source$_sum, _source$sum;
    let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intersectionOptions = _ref.intersectionOptions,
      source = _ref.source;
    super();
    _classPrivateMethodInitSpec(this, _PayfooterReminderButtonCounter_brand);
    _classPrivateFieldInitSpec(this, _source, void 0);
    _classPrivateFieldInitSpec(this, _initIsSubscription, false);
    _classPrivateFieldInitSpec(this, _intersectionOptions, void 0);
    _classPrivateFieldInitSpec(this, _payfooterInViewPort, false);
    _classPrivateFieldInitSpec(this, _footerInViewPort, false);
    _classPrivateFieldInitSpec(this, _clicked, false);
    _classPrivateFieldInitSpec(this, _animations, void 0);
    _classPrivateFieldInitSpec(this, _observer, null);
    _classPrivateFieldInitSpec(this, _hasAppended, false);
    _classPrivateFieldInitSpec(this, _elIcon, void 0);
    _classPrivateFieldInitSpec(this, _elBody, void 0);
    _classPrivateFieldInitSpec(this, _elAmount, void 0);
    _classPrivateFieldInitSpec(this, _elButton, void 0);
    _classPrivateFieldInitSpec(this, _elPayfooter, void 0);
    _classPrivateFieldInitSpec(this, _elPagefooter, void 0);
    _classPrivateFieldInitSpec(this, _onSumUpdated, payload => {
      if (payload && typeof payload.amount === 'number') {
        this.setSum(payload.amount);
      }
      _assertClassBrand(_PayfooterReminderButtonCounter_brand, this, _evaluateVisibility).call(this);
    });
    _classPrivateFieldInitSpec(this, _clickHandler, () => {
      _classPrivateFieldSet(_clicked, this, true);
      this.hide();
      _assertClassBrand(_PayfooterReminderButtonCounter_brand, this, _resolveTargets).call(this);
      if (_classPrivateFieldGet(_elPayfooter, this)) {
        const rectTop = _classPrivateFieldGet(_elPayfooter, this).getBoundingClientRect().top;
        const scrollToPosition = rectTop - window.innerHeight + _classPrivateFieldGet(_elPayfooter, this).offsetHeight + window.pageYOffset;
        if (Number.isFinite(scrollToPosition)) {
          gsap.to(window, {
            duration: 0.5,
            scrollTo: scrollToPosition
          });
        }
      }
      _classPrivateFieldSet(_clicked, this, false);
      this.track();
    });
    if (source) {
      _classPrivateFieldSet(_source, this, source);
      _classPrivateFieldSet(_initIsSubscription, this, source.buttons[0].title.includes('vecka'));
    }
    _assertClassBrand(_PayfooterReminderButtonCounter_brand, this, _createDomElements).call(this, {
      isSubscription: _classPrivateFieldGet(_initIsSubscription, this)
    });
    _classPrivateFieldSet(_intersectionOptions, this, intersectionOptions);
    _classPrivateFieldSet(_animations, this, new svs.tur.payfooter_reminder_button_counter.animations(this.$el, _classPrivateFieldGet(_elAmount, this)));
    this.sum = 0;
    if (source) {
      source.on(svs.tur.payfooter.SUM_UPDATED, _classPrivateFieldGet(_onSumUpdated, this), this);
    }
    const initialSum = (_ref2 = (_source$_sum = source === null || source === void 0 ? void 0 : source._sum) !== null && _source$_sum !== void 0 ? _source$_sum : source === null || source === void 0 || (_source$sum = source.sum) === null || _source$sum === void 0 ? void 0 : _source$sum.amount) !== null && _ref2 !== void 0 ? _ref2 : 0;
    this.setSum(initialSum);
  }
  set payfooterInViewPort(state) {
    _classPrivateFieldSet(_payfooterInViewPort, this, Boolean(state));
    _assertClassBrand(_PayfooterReminderButtonCounter_brand, this, _evaluateVisibility).call(this);
  }
  get payfooterInViewPort() {
    return _classPrivateFieldGet(_payfooterInViewPort, this);
  }
  set footerInViewPort(state) {
    _classPrivateFieldSet(_footerInViewPort, this, Boolean(state));
    _assertClassBrand(_PayfooterReminderButtonCounter_brand, this, _evaluateVisibility).call(this);
  }
  get footerInViewPort() {
    return _classPrivateFieldGet(_footerInViewPort, this);
  }
  classNames() {
    return ['payfooter-reminder-button-counter'];
  }
  setSum(amount) {
    this.sum = amount;
    if (_classPrivateFieldGet(_animations, this) && typeof _classPrivateFieldGet(_animations, this).animateCounter === 'function') {
      _classPrivateFieldGet(_animations, this).animateCounter(this.sum);
    } else if (_classPrivateFieldGet(_elAmount, this)) {
      _classPrivateFieldGet(_elAmount, this).textContent = String(this.sum);
    }
  }
  show() {
    if (!_classPrivateFieldGet(_hasAppended, this)) {
      _assertClassBrand(_PayfooterReminderButtonCounter_brand, this, _appendDomElements).call(this);
    }
    _assertClassBrand(_PayfooterReminderButtonCounter_brand, this, _resolveTargets).call(this);
    if (this.sum !== 0 && _classPrivateFieldGet(_animations, this) && typeof _classPrivateFieldGet(_animations, this).buttonCounterUp === 'function') {
      _classPrivateFieldGet(_animations, this).buttonCounterUp();
    }
  }
  hide() {
    if (!_classPrivateFieldGet(_hasAppended, this)) {
      return;
    }
    if (_classPrivateFieldGet(_animations, this) && typeof _classPrivateFieldGet(_animations, this).buttonCounterDown === 'function') {
      _classPrivateFieldGet(_animations, this).buttonCounterDown();
    }
  }
  track() {
    svs.components.analytics.trackEvent({
      category: 'bottom sheet',
      action: 'payfooter_cta',
      opt_label: svs.numbergames.productMapping.getProductName(svs.page.data.templateConfig.branding),
      opt_value: this.sum
    });
  }
  destroy() {
    if (_classPrivateFieldGet(_source, this)) {
      _classPrivateFieldGet(_source, this).off(svs.tur.payfooter.SUM_UPDATED, this);
      _classPrivateFieldSet(_source, this, null);
    }
    _assertClassBrand(_PayfooterReminderButtonCounter_brand, this, _removeDomElements).call(this);
    super.destroy && super.destroy();
  }
  updateButtonTitle(isSubscription) {
    _classPrivateFieldGet(_elButton, this).innerHTML = '';
    _classPrivateFieldGet(_elButton, this).appendChild(_classPrivateFieldGet(_elAmount, this));
    const text = isSubscription ? ' kr/v - till betalning' : ' kr - till betalning';
    _classPrivateFieldGet(_elButton, this).appendChild(document.createTextNode(text));
    _classPrivateFieldGet(_elButton, this).insertAdjacentHTML('beforeend', _classPrivateFieldGet(_elIcon, this));
  }
}
function _createDomElements(_ref3) {
  let _ref3$isSubscription = _ref3.isSubscription,
    isSubscription = _ref3$isSubscription === void 0 ? false : _ref3$isSubscription;
  _classPrivateFieldSet(_elIcon, this, svs.ui.icon.partials.icon({
    icon: 'scroll-down',
    color: 'fc-white'
  }));
  this.$el.classList.add(...this.classNames());
  _classPrivateFieldSet(_elBody, this, this.createElement('reminder-body'));
  _classPrivateFieldSet(_elAmount, this, document.createElement('span'));
  _classPrivateFieldGet(_elAmount, this).textContent = '0';
  _classPrivateFieldSet(_elButton, this, document.createElement('button'));
  _classPrivateFieldGet(_elButton, this).className = 'btn reminder-btn btn-inverted';
  _classPrivateFieldGet(_elButton, this).appendChild(_classPrivateFieldGet(_elAmount, this));
  _classPrivateFieldGet(_elButton, this).insertAdjacentHTML('beforeend', _classPrivateFieldGet(_elIcon, this));
  _classPrivateFieldGet(_elBody, this).appendChild(_classPrivateFieldGet(_elButton, this));
  this.$el.appendChild(_classPrivateFieldGet(_elBody, this));
  this.updateButtonTitle(isSubscription);
}
function _resolveTargets() {
  if (!_classPrivateFieldGet(_elPayfooter, this)) {
    _classPrivateFieldSet(_elPayfooter, this, document.querySelector('.payfooter'));
  }
  if (!_classPrivateFieldGet(_elPagefooter, this)) {
    _classPrivateFieldSet(_elPagefooter, this, document.querySelector('.page-footer'));
  }
}
function _appendDomElements() {
  if (!_classPrivateFieldGet(_hasAppended, this)) {
    _assertClassBrand(_PayfooterReminderButtonCounter_brand, this, _resolveTargets).call(this);
    document.body.appendChild(this.$el);
    _assertClassBrand(_PayfooterReminderButtonCounter_brand, this, _addEventListeners).call(this);
    _classPrivateFieldSet(_hasAppended, this, true);
  }
}
function _removeDomElements() {
  if (_classPrivateFieldGet(_hasAppended, this)) {
    _assertClassBrand(_PayfooterReminderButtonCounter_brand, this, _removeEventListeners).call(this);
    if (_classPrivateFieldGet(_observer, this)) {
      try {
        _classPrivateFieldGet(_observer, this).disconnect();
      } catch (e) {}
      _classPrivateFieldSet(_observer, this, null);
    }
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    _classPrivateFieldSet(_hasAppended, this, false);
  }
}
function _addEventListeners() {
  _assertClassBrand(_PayfooterReminderButtonCounter_brand, this, _resolveTargets).call(this);
  if (_classPrivateFieldGet(_elPayfooter, this) || _classPrivateFieldGet(_elPagefooter, this)) {
    _classPrivateFieldSet(_observer, this, new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === _classPrivateFieldGet(_elPayfooter, this)) {
          this.payfooterInViewPort = entry.isIntersecting;
        }
        if (entry.target === _classPrivateFieldGet(_elPagefooter, this)) {
          this.footerInViewPort = entry.isIntersecting;
        }
      });
    }, _classPrivateFieldGet(_intersectionOptions, this)));
    if (_classPrivateFieldGet(_elPayfooter, this)) {
      _classPrivateFieldGet(_observer, this).observe(_classPrivateFieldGet(_elPayfooter, this));
    }
    if (_classPrivateFieldGet(_elPagefooter, this)) {
      _classPrivateFieldGet(_observer, this).observe(_classPrivateFieldGet(_elPagefooter, this));
    }
  }
  _classPrivateFieldGet(_elButton, this).addEventListener('click', _classPrivateFieldGet(_clickHandler, this));
}
function _removeEventListeners() {
  _classPrivateFieldGet(_elButton, this).removeEventListener('click', _classPrivateFieldGet(_clickHandler, this));
}
function _evaluateVisibility() {
  const inView = Boolean(_classPrivateFieldGet(_payfooterInViewPort, this) || _classPrivateFieldGet(_footerInViewPort, this));
  if (inView) {
    this.hide();
  } else {
    this.show();
  }
}
svs.tur.payfooter_reminder_button_counter = PayfooterReminderButtonCounter;

 })(window);